import { render, staticRenderFns } from "./TemplateContent.vue?vue&type=template&id=0f3e808a&scoped=true&"
import script from "./TemplateContent.vue?vue&type=script&lang=js&"
export * from "./TemplateContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3e808a",
  null
  
)

export default component.exports